export const mediaList = {
	REQUEST: 'MEDIA_LIST_REQUEST',
	RECEIVE: 'MEDIA_LIST_RECEIVE',
	SHOWE_ERROR: 'SHOWE_ERROR',
	CLEAN_ERROR: 'CLEAN_ERROR'
};



// WEBPACK FOOTER //
// ./src/constants/mediaList.constants.js